export * from './auth.service';
import { AuthService } from './auth.service';
export * from './auth.serviceInterface';
export * from './cardIssuerFees.service';
import { CardIssuerFeesService } from './cardIssuerFees.service';
export * from './cardIssuerFees.serviceInterface';
export * from './logs.service';
import { LogsService } from './logs.service';
export * from './logs.serviceInterface';
export * from './permissions.service';
import { PermissionsService } from './permissions.service';
export * from './permissions.serviceInterface';
export * from './pix.service';
import { PixService } from './pix.service';
export * from './pix.serviceInterface';
export * from './privateApiDreampayComBr.service';
import { PrivateApiDreampayComBrService } from './privateApiDreampayComBr.service';
export * from './privateApiDreampayComBr.serviceInterface';
export * from './roles.service';
import { RolesService } from './roles.service';
export * from './roles.serviceInterface';
export * from './settings.service';
import { SettingsService } from './settings.service';
export * from './settings.serviceInterface';
export * from './users.service';
import { UsersService } from './users.service';
export * from './users.serviceInterface';
export const APIS = [
  AuthService,
  CardIssuerFeesService,
  LogsService,
  PermissionsService,
  PixService,
  PrivateApiDreampayComBrService,
  RolesService,
  SettingsService,
  UsersService,
];
